var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useReducer } from 'react';
import { reducer } from '../store/reducer';
import { AuthorizationProvider } from './AuthorizationProvider';
import { StoreContext } from './Context';
import { toInitialState } from './utils';
export function IntegrationApiProvider(props) {
    var contextValue = useReducer(reducer, undefined, toInitialState(props));
    return (React.createElement(StoreContext.Provider, { value: contextValue },
        React.createElement(AuthorizationProvider, __assign({}, props))));
}
